import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrowserEmail from './BrowserEmail';
import { config } from '../config';
import UserMenu from './UserMenu';

const BrowserEmailWrapper: React.FC = () => {
  const navigate = useNavigate();
  const [companyId, setCompanyId] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authToken = localStorage.getItem('dashzap_token');
    if (!authToken) {
      navigate('/');
      return;
    }

    try {
      // Decode JWT to get company info
      const payload = JSON.parse(atob(authToken.split('.')[1]));

      if (payload.companyId === 'onboarding') {
        navigate('/onboarding');
        return;
      }

      setCompanyId(payload.companyId);
      setToken(authToken);
    } catch (error) {
      console.error('Error parsing token:', error);
      navigate('/');
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!companyId || !token) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/admin-dashboard')}
                className="text-gray-600 hover:text-gray-900"
              >
                ← Back to Dashboard
              </button>
              <h1 className="text-2xl font-bold text-gray-900">Dashzap Admin</h1>
            </div>
          </div>
        </div>
      </header>

      {/* User Menu */}
      <UserMenu />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <BrowserEmail
          companyId={companyId}
          apiBaseUrl={config.API_BASE_URL}
          token={token}
        />
      </main>
    </div>
  );
};

export default BrowserEmailWrapper;
